import React from "react";
import FBLike from "../../../../assets/images/fb-like.png";
import FBLove from "../../../../assets/images/fb-love.png";
import FBCare from "../../../../assets/images/fb-care.png";
import FBHaha from "../../../../assets/images/fb-haha.png";
import FBWow from "../../../../assets/images/fb-wow.png";
import FBSad from "../../../../assets/images/fb-sad.png";
import FBAngry from "../../../../assets/images/fb-angry.png";

export default function SocialReactionsTray({ reaction_metadata }) {
  const {
    angry_count = 0,
    care_count = 0,
    haha_count = 0,
    like_count = 0,
    sad_count = 0,
    wow_count = 0,
    love_count = 0,
  } = reaction_metadata;
  return (
    <div className="fbLikeTooltip">
      <div className="fbLikeCounts">
        <div className="fbcWrap">
          <img src={FBLike} />
          <div className="fbText">
            <label>Likes</label>
            <span>{like_count}</span>
          </div>
        </div>
        <div className="fbcWrap">
          <img src={FBLove} />
          <div className="fbText">
            <label>Love</label>
            <span>{love_count}</span>
          </div>
        </div>
        <div className="fbcWrap">
          <img src={FBCare} />
          <label>Care</label>
          <span>{care_count || 0}</span>
        </div>
        <div className="fbcWrap">
          <img src={FBHaha} />
          <div className="fbText">
            <label>Haha</label>
            <span>{haha_count}</span>
          </div>
        </div>
        <div className="fbcWrap">
          <img src={FBWow} />
          <div className="fbText">
            <label>Wow</label>
            <span>{wow_count}</span>
          </div>
        </div>
        <div className="fbcWrap">
          <img src={FBSad} />
          <div className="fbText">
            <label>Sad</label>
            <span>{sad_count}</span>
          </div>
        </div>
        <div className="fbcWrap">
          <img src={FBAngry} />
          <div className="fbText">
            <label>Angry</label>
            <span>{angry_count}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

SocialReactionsTray.defaultProps = {
  reaction_metadata: {},
};
